<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book is dedicated to those AITECE teachers who so generously spent years teaching English in China, convinced that they had something important to offer; they still do. In particular I dedicate this book to Greg, Bernadette, Joe and especially Brian, who has since passed away.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?207e9d36